import ImageCropperModal from './ImageCropperModal';

export default ImageCropperModal;
